import {
  T3,
  Tile,
  DocumentIcon,
} from 'ia-react-core';
import styled from 'styled-components';

export const StyledTile = styled(Tile)`
  padding-bottom: 48px;
  padding-top: 48px;
  text-align:center;
`;

export const StyledTitle = styled(T3)`
  margin-top: 24px;
  margin-bottom: 16px;
`;

export const StyledNewsIcon = styled(DocumentIcon)`
  color: ${({ theme }) => theme.colors.blue6};
`;
